en:
  categories:
    groups:
      '100':
        label: Basic settings
        items:
          '101': Try something new
          '102': Tasks after the game
          '103': Talking tasks
          '104': Sex after anal
          '105': Blowjob after anal
          '106': Repeat after video
      '200':
        label: Classic sex
        items:
          '201': Strip task
          '202': Kisses
          '203': Petting
          '204': Poses with male activity
          '205': Poses with female activity
          '206': Talking tasks
      '300':
        label: Oral sex
        items:
          '301': Blowjob
          '302': Caress man's balls
          '303': Anilingus to man
          '304': Cunnilingus
          '305': Facesitting
          '306': Anilingus to woman
      '400':
        label: Masturbation
        items:
          '401': Girl masturbate man
          '402': Masturbate between boobs
          '403': Solo man masturbation
          '404': Male anal masturbation
          '405': Man masturbate girl
          '406': Solo girl masturbation
          '407': Female anal masturbation
      '500':
        label: Anal sex
        items:
          '501': Simple poses
          '502': Difficult poses
      '600':
        label: Orgasm
        items:
          '601': Orgasm together
          '602': Cum on girl's body
          '603': Cum on girl's tits
          '604': Cum on girl's face
          '605': Cum in girl's mouth
          '606': Cum in girl's ass
          '607': Cum in girl's pussy
          '608': Cum on yourself
          '609': Others
          '610': Cum from masturbation
          '611': Cum from oral sex
      '700':
        label: Sex toys
        items:
          '701': Vibrator
          '702': Butt plug
          '703': Dildo
          '704': Strapon
      '800':
        label: B.D.S.M.
        items:
          '801': Dominance and submission
          '802': Man domination
          '803': Bondage girl
          '804': Female submission
          '805': Female dominance
          '806': Male bondage
          '807': Strapon girl
          '808': Male submission
      '900':
        label: Others
        items:
          '901': Foot fetish
          '902': Take photo / video
          '903': Watching porn
          '904': Male golden shower
          '905': Massage for girl
          '906': Female golden shower
          '907': Massage for a man
          '908': Sexual role-play

ru:
  categories:
    groups:
      '100':
        label: Основные настройки
        items:
          '101': Добавить разнообразие
          '102': Отложенные задания
          '103': Разговорные задания
          '104': Секс после анала
          '105': Минет после анала
          '106': Повторять за видео
      '200':
        label: Классический секс
        items:
          '201': Раздевание
          '202': Поцелуи
          '203': Петтинг
          '204': Позы с активностью мужчины
          '205': Позы с активностью женщины
          '206': Эротическая беседа
      '300':
        label: Оральный секс
        items:
          '301': Минет
          '302': Ласки яичек
          '303': Анилингус мужчине
          '304': Кунилингус
          '305': Фейсситтинг
          '306': Анилингус женщине
      '400':
        label: Мастурбация
        items:
          '401': Девушка мужчине
          '402': Мастурбация грудью
          '403': Парень сам себе
          '404': Мужская анальная
          '405': Мужчина девушке
          '406': Девушка сама себе
          '407': Женская анальная
      '500':
        label: Анальный секс
        items:
          '501': Простые позы
          '502': Сложные позы
      '600':
        label: Окончание
        items:
          '601': Попробовать вместе
          '602': На тело девушки
          '603': На грудь девушки
          '604': На лицо девушки
          '605': В рот девушки
          '606': В попку девушки
          '607': В киску девушки
          '608': На себя
          '609': Прочие
          '610': От мастурбации
          '611': От оральных ласк
      '700':
        label: Игрушки
        items:
          '701': Вибратор
          '702': Анальная пробка
          '703': Фаллоимитатор
          '704': Страпон
      '800':
        label: БДСМ
        items:
          '801': Власть и подчинение (БДСМ)
          '802': Подчинение парню
          '803': Связывание девушки
          '804': Унижение девушки
          '805': Подчинение девушке
          '806': Связывание парня
          '807': Девушка со страпоном
          '808': Унижение парня
      '900':
        label: Другое
        items:
          '901': Фут фетиш
          '902': Сделать фото / видео
          '903': Просмотр порно
          '904': Золотой дождь от мужчины
          '905': Массаж ей
          '906': Золотой дождь от девушки
          '907': Массаж ему
          '908': Ролевые игры

de:
  categories:
    groups:
      '100':
        label: Grundeinstellungen
        items:
          '101': Sorgen Sie für Abwechslung
          '102': Aufgeschobene Jobs
          '103': Sprechaufgaben
          '104': Sex nach dem Analsex
          '105': Blowjob nach Anal
          '106': Nach dem Video wiederholen
      '200':
        label: Klassischer Sex
        items:
          '201': Streifen
          '202': Küsse
          '203': Petting
          '204': Posen mit männlicher Aktivität
          '205': Posen mit Frauenaktivität
          '206': Erotische Unterhaltung
      '300':
        label: Oralsex
        items:
          '301': Blowjob
          '302': Die Hoden streicheln
          '303': Anilingus für einen Mann
          '304': Cunnilingus
          '305': Facesitting
          '306': Anilingus für eine Frau
      '400':
        label: Masturbation
        items:
          '401': Vom Mädchen zum Mann
          '402': Brustmasturbation
          '403': Der Typ ist auf sich allein gestellt
          '404': Männlicher Analsex
          '405': Mann zu Mädchen
          '406': Das Mädchen ist allein
          '407': Weiblicher Analsex
      '500':
        label: Analsex
        items:
          '501': Einfache Posen
          '502': Schwierige Posen
      '600':
        label: Ende
        items:
          '601': Probieren Sie es gemeinsam aus
          '602': Am Körper eines Mädchens
          '603': Auf der Brust des Mädchens
          '604': Auf dem Gesicht eines Mädchens
          '605': Im Mund eines Mädchens
          '606': Im Arsch des Mädchens
          '607': In der Muschi eines Mädchens
          '608': Sich
          '609': Andere
          '610': Von Masturbation
          '611': Vom Oralsex
      '700':
        label: Spielzeug
        items:
          '701': Vibrator
          '702': Buttplug
          '703': Dildo
          '704': Strapon
      '800':
        label: BDSM
        items:
          '801': Macht und Unterwerfung (BDSM)
          '802': Unterwerfung unter einen Mann
          '803': Mädchen fesselt
          '804': Demütigung eines Mädchens
          '805': Unterwerfung unter ein Mädchen
          '806': Einen Kerl fesseln
          '807': Mädchen mit Strapon
          '808': Demütigung eines Mannes
      '900':
        label: Andere
        items:
          '901': Fußfetisch
          '902': Machen Sie ein Foto/Video
          '903': Pornos gucken
          '904': Natursekt von einem Mann
          '905': Massiere sie
          '906': Natursekt von einem Mädchen
          '907': Massiere ihn
          '908': Rollenspiele

es:
  categories:
    groups:
      '100':
        label: Configuraciones básicas
        items:
          '101': Añade variedad
          '102': Trabajos diferidos
          '103': Tareas de habla
          '104': Sexo despues del anal
          '105': Mamada después del anal
          '106': Repetir después del vídeo
      '200':
        label: sexo clasico
        items:
          '201': Banda
          '202': Besos
          '203': Caricias
          '204': Poses con actividad masculina.
          '205': Poses con actividad de mujer.
          '206': Conversación erótica
      '300':
        label: sexo oral
        items:
          '301': Mamada
          '302': Acariciando los testículos
          '303': Anilingus para un hombre
          '304': cunnilingus
          '305': sentado en la cara
          '306': Anilingus para mujer
      '400':
        label: Masturbación
        items:
          '401': Chica a hombre
          '402': masturbación mamaria
          '403': El chico esta solo
          '404': Anal masculino
          '405': hombre a chica
          '406': La chica esta sola
          '407': Anal femenino
      '500':
        label: sexo anal
        items:
          '501': Poses simples
          '502': Poses difíciles
      '600':
        label: Fin
        items:
          '601': Pruébalo juntos
          '602': En el cuerpo de una niña
          '603': En el pecho de la niña
          '604': En la cara de una chica
          '605': En la boca de una chica
          '606': En el culo de la chica
          '607': En el coño de una chica
          '608': Para ti mismo
          '609': Otros
          '610': De la masturbación
          '611': Del sexo oral
      '700':
        label: juguetes
        items:
          '701': Vibrador
          '702': tapón anal
          '703': Consolador
          '704': arnés
      '800':
        label: sadomasoquismo
        items:
          '801': Poder y sumisión (BDSM)
          '802': Sumisión a un chico
          '803': chica atando
          '804': humillación de niña
          '805': Sumisión a una chica
          '806': Atar a un chico
          '807': chica con arnés
          '808': Humillación de un chico
      '900':
        label: Otro
        items:
          '901': fetiche de pies
          '902': Tomar foto/video
          '903': viendo porno
          '904': Lluvia dorada de un hombre
          '905': masajearla
          '906': Lluvia dorada de una niña
          '907': masajearlo
          '908': Juegos de rol

fr:
  categories:
    groups:
      '100':
        label: Paramètres de base
        items:
          '101': Ajouter de la variété
          '102': Emplois différés
          '103': Tâches orales
          '104': Sexe après anal
          '105': Fellation après anal
          '106': Répéter après la vidéo
      '200':
        label: Sexe classique
        items:
          '201': Bande
          '202': Bisous
          '203': Caresse
          '204': Pose avec une activité masculine
          '205': Pose avec une activité féminine
          '206': Conversation érotique
      '300':
        label: Sexe oral
        items:
          '301': Fellation
          '302': Caresser les testicules
          '303': Anilingus pour un homme
          '304': Cunnilingus
          '305': Face-sitting
          '306': Anilingus pour une femme
      '400':
        label: Masturbation
        items:
          '401': Fille à homme
          '402': Se masturber
          '403': Le gars est tout seul
          '404': Anal masculin
          '405': Homme à fille
          '406': La fille est seule
          '407': Anal féminin
      '500':
        label: Sexe anal
        items:
          '501': Poses simples
          '502': Poses difficiles
      '600':
        label: Fin
        items:
          '601': Essayez-le ensemble
          '602': Sur le corps d'une fille
          '603': Sur la poitrine de la fille
          '604': Sur le visage d'une fille
          '605': Dans la bouche d'une fille
          '606': Dans le cul de la fille
          '607': Dans la chatte d'une fille
          '608': À vous-même
          '609': Autres
          '610': De la masturbation
          '611': Du sexe oral
      '700':
        label: Jouets
        items:
          '701': Vibreur
          '702': Plug anal
          '703': Godemiché
          '704': gode-ceinture
      '800':
        label: Sado-Sado
        items:
          '801': Pouvoir et soumission (BDSM)
          '802': Soumission à un mec
          '803': Fille attachant
          '804': Humiliation de fille
          '805': Soumission à une fille
          '806': Attacher un mec
          '807': fille avec strapon
          '808': Humiliation d'un mec
      '900':
        label: Autre
        items:
          '901': Fétichisme des pieds
          '902': Prendre une photo/vidéo
          '903': Regarder du porno
          '904': Douche dorée d'un homme
          '905': Massez-la
          '906': Douche dorée d'une fille
          '907': Massez-le
          '908': Jeux de rôle
